import React, { useState } from "react";
import {toast} from 'react-hot-toast'
import {
  Button,
  Container,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { saveToken } from "../../redux/user/UserAction";


const VerifyEmail = ({newUserId}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const uid = useSelector((state)=>state.user.uid)

  // eslint-disable-next-line
  const [error, setError] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  // Function to handle code input change
  const handleCodeChange = (event) => {
    const newCode = event.target.value;
    setVerificationCode(newCode);
    setIsButtonDisabled(newCode.length !== 6); // Disable button until 6 characters are entered
  };

  // Function to handle form submission
  const handleSubmit = async (event) => {
    console.log(uid)
    event.preventDefault();
    setLoading(true)
    const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ verification_code: verificationCode, }),
      };
  
      try {
        const response = await fetch(
          `https://salama-api.onrender.com/users/${uid}/verify_code`,
          options
        ); /**Replace with backend endpoint*/
        if (response.ok) {
        const responseData = await response.json();
        console.log(responseData)
        toast.success(`${responseData.message}`); 
        dispatch(saveToken({token: responseData.token, uid: uid}))
        setLoading(false)
        navigate("/Kyc");
        }else {
          const errorResponse = await response.json();
          setLoading(false)
          toast.error(errorResponse.message)
          setError(
            errorResponse.message ||
              "Something went wrong. Please try again later."
          );
        }

      } catch (error) {
        console.error("Failed to fetch", error);
        setError("Server error occurred. P")
      }
    // Reset the code input field
    setVerificationCode("");
    setIsButtonDisabled(true);
  };

  return (
    <Container maxWidth="sm" className="min-h-screen flex items-center">
      <div className="p-4 w-5/6 h-full">
        <Typography
          variant="h3"
          align="center"
          className="mb-4 text-success"
          gutterBottom
        >
          Email Verification
        </Typography>
        <Typography
          variant="subtitle1"
          align="center"
          className="mb-4 text-gray-500"
          gutterBottom
        >
          Enter the 6-digit code sent to your email.
        </Typography>
        <form onSubmit={handleSubmit}>
          <FormControl fullWidth sx={{ marginBottom: 4 }}>
            <TextField
              label="Verification Code"
              variant="outlined"
              value={verificationCode}
              onChange={handleCodeChange}
              className="mb-3"
              required
              inputProps={{ maxLength: 6 }}
            />
          </FormControl>

          <Button
            variant="contained"
            color="primary"
            type="submit"
            className="mt-4"
            fullWidth
            onClick={handleSubmit}
            disabled={isButtonDisabled || loading}
          >
            {loading ? 'Loading...' : 'Verify'}
          </Button>
        </form>
      </div>
    </Container>
  );
}

export default VerifyEmail
